"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliders = void 0;
const splide_1 = require("@splidejs/splide");
const sliders = () => {
    let quickLinks = document.getElementsByClassName('quick-links-slider__slides');
    for (let i = 0; i < quickLinks.length; i++) {
        new splide_1.default(quickLinks[i], {
            perPage: 3,
            type: 'loop',
            focus: 'center',
            breakpoints: {
                767: {
                    perPage: 1,
                    padding: { left: '4rem', right: '4rem' }
                },
            }
        }).mount();
    }
    let info = document.getElementsByClassName('info-slider__slides');
    for (let i = 0; i < info.length; i++) {
        new splide_1.default(info[i], {
            perPage: 3,
            type: 'loop',
            focus: 'center',
            breakpoints: {
                767: {
                    perPage: 1
                },
            }
        }).mount();
    }
    let contentBox = document.getElementsByClassName('content-box-slider__slides');
    for (let i = 0; i < contentBox.length; i++) {
        new splide_1.default(contentBox[i], {
            perPage: 1,
            type: 'loop'
        }).mount();
    }
    let icon = document.getElementsByClassName('icon-slider__slides');
    for (let i = 0; i < icon.length; i++) {
        new splide_1.default(icon[i], {
            perPage: 5,
            type: 'loop',
            focus: 'center',
            breakpoints: {
                1200: {
                    perPage: 3
                },
                767: {
                    perPage: 1
                },
            }
        }).mount();
    }
    let gallery = document.querySelector('.gallery__slides');
    let galleryThumbs = document.querySelector('.gallery__thumbs');
    if (gallery && galleryThumbs) {
        let galleryMainSlider = new splide_1.default(gallery, {
            perPage: 1,
            type: 'loop',
            pagination: false,
            arrows: false,
            breakpoints: {
                767: {
                    pagination: true,
                    arrows: true,
                },
            }
        });
        let galleryThumbsSlider = new splide_1.default(galleryThumbs, {
            perPage: 5,
            type: 'loop',
            focus: 'center',
            gap: 16,
            pagination: false,
            isNavigation: true,
            breakpoints: {
                1200: {
                    perPage: 3
                },
            }
        });
        galleryMainSlider.sync(galleryThumbsSlider);
        galleryMainSlider.mount();
        galleryThumbsSlider.mount();
    }
};
exports.sliders = sliders;
